<template>
    <div>
        <b-modal :model-value="showConfirmDialog" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                <!-- <b-button style="background-color: #cd2838; width: 35px; height: 35px;" class="md-fab md-primary" @click="deleteCuenta(item.id)"> --> 
                    <i style="background-color: #cd2838; color: white; width: 35px; height: 35px; border-radius: 4px;">warning</i>
                <!-- </b-button> -->
            </div>
            <div>
                <b-row class="mb-3">
                    <b-col v-if="borraUno" md="5" lg="7" class="mx-auto">
                        <h5>{{ labels.texto }}</h5> 
                    </b-col>
                    <b-col v-if="!borraUno" md="5" lg="7" class="mx-auto">
                        <h5>{{ labels.texto1 }}</h5> 
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <b-button class="md-primary" @click="confirmDelete">{{ labels.aceptar }}</b-button> 
                    <b-button class="md-accent" @click="cancelDelete">{{ labels.cancelar }}</b-button> 
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: 'DialogConfirm',
    props: ['showConfirmDialog','borraUno'],
    data: () => ({
      
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar Niif",
                    texto : "¿Seguro desea eliminar este registro?",
                    texto1 : "¿Seguro desea eliminar todos los registros?",
                    aceptar : "Aceptar",
                    cancelar : "Cancelar"
                }
            }else{
                return {
                    title: "Edit Niif",
                    texto : "Are you sure you want to delete this record?",
                    texto1 : "Are you sure you want to delete all records?",
                    aceptar : "Accept",
                    cancelar : "Cancel"
                }
            }
        }
    },
    methods: {
        cancelDelete(){
            this.$emit('cancelDel', false);
        },
        confirmDelete(){
            this.$emit('confirmDelete');
        }
    }
}
</script>
<style src="../main.css"></style> 